import React from 'react'

// Hooks
import { useContext, useEffect } from 'react'

// Styles 
import styles from '../styles/Authenticate.scss'

// Components
import { Row, Column } from 'columns'
import { Spinner } from 'spinner'
import Login from './Login'
import Signup from './Signup'

// Context
import { AuthContext } from '../context'
import { useTranslation } from 'react-i18next'

const Authenticate: React.FC<{ children?: React.ReactNode }> = (props) => {

    const auth = useContext(AuthContext)
    const { t } = useTranslation()

    useEffect(() => { 
        auth.actions.authenticate()
    }, [])

    if(auth.fetching) return <Spinner />
    if(auth.user) return <div>{props.children}</div>

    return (
        <Row className={styles.authenticate}>
            <Column>
                <h2>{t('login.loginHeader')}</h2>
                <Login />
            </Column>
            <Column>
                <h2>{t('signup.signupHeader')}</h2>
                <Signup />
            </Column>
        </Row>
    )

}

export default Authenticate